export enum Tokens {
  ColorWhite = '#FFFFFF',
  ColorBackground = '#F3F4F8',
  ColorBackgroundSecondary = '#F4F4F5',
  ColorBackgroundTertiary = '#E0E0E0',
  ColorLightest = '#F8F9FA',
  ColorHover = '#EEF0F5',
  ColorUIPrimary = '#01C38D',
  ColorUIPrimaryDim = '#01A779',
  ColorUIPrimaryLight = '#A8E6D0',
  ColorUISecondaryLight = '#F0F0F0',
  ColorUISuccess = '#10B981',
  ColorUISuccessLight = '#D1FAE5',
  ColorUIWarnLight = '#FFF2D1',
  ColorUIWarn = '#FFC765',
  ColorUIWarnDark = '#FF7E26',
  ColorUIWarnDim = '#FAA111',
  ColorUIDanger = '#FF4C64',
  ColorUIDangerDim = '#CE4A64',
  ColorUIInfo = '#6366F1',
  ColorUIInfoLight = '#E0E7FF',
  ColorUIInfoDim = '#4F46E5',
  ColorUIPurple = '#9333EA',
  ColorUIPurpleLight = '#F3E8FF',

  ColorTextPrimary = '#13141C',
  ColorTextSecondary = '#5E6287',
  ColorTextSecondaryForeground = '#18181B',
  ColorTextTertiary = '#94A2BC',
  ColorTextQuaternary = '#C7C7C7',
  ColorLight = '#CBD1E6',
  ColorBorder = '#DEE2EF',

  RootWithPaddingWidth = '64.75rem',
  DefaultInputWidth = '20rem',
  HeightInput = '3.25rem',
  RadiusInput = '10px',
  HeaderHeight = '78px',
}
